<template>
    <ul class="list-unstyled fm-tree-branch">
        <li v-for="(directory, index) in subDirectories" v-bind:key="index">
            <p class="unselectable"
               v-bind:class="{'selected': isDirectorySelected(directory.path)}"
               v-on:click="selectDirectory(directory.path)"
               v-on:dblclick="selectPath(directory.path)">
                <i class="fas fa-lg mr-2"
                   v-if="directory.props.hasSubdirectories"
                   v-on:click.stop="showSubdirectories(
                        directory.path,
                        directory.props.showSubdirectories
                      )"
                   v-bind:class="[arrowState(index)
                    ? 'fa-caret-down'
                    : 'fa-caret-right'
                   ]"/>
                <i class="fas fa-caret-right fa-lg mr-2" style="opacity:0" v-else/>
                <img width="20" class="mr-3" src="../../assets/folder.png" alt="">
                {{ directory.basename }}
            </p>

            <transition name="fade-tree">
                <branch-select v-show="arrowState(index)"
                        v-if="directory.props.hasSubdirectories"
                        v-bind:parent-id="directory.id"
                         @selected="selectPath">
                </branch-select>
            </transition>
        </li>
    </ul>
</template>

<script>
export default {
  name: 'BranchSelect',
  props: {
    parentId: { type: Number, required: true },
  },
  computed: {
    /**
     * Subdirectories for selected parent
     * @returns {*}
     */
    subDirectories() {
      return this.$store.getters['tree/directories'].filter((item) => item.parentId === this.parentId);
    },
  },
  methods: {
    /**
     * Check, is this directory selected?
     * @param path
     * @returns {boolean}
     */
    isDirectorySelected(path) {
      return this.$store.state.left.selectedDirectory === path;
    },

    /**
     * Show subdirectories - arrow
     * @returns {boolean}
     * @param index
     */
    arrowState(index) {
      return this.subDirectories[index].props.showSubdirectories;
    },

    /**
     * Show/Hide subdirectories
     * @param path
     * @param showState
     */
    showSubdirectories(path, showState) {
      if (showState) {
        // hide
        this.$store.dispatch('tree/hideSubdirectories', path);
      } else {
        // show
        this.$store.dispatch('tree/showSubdirectories', path);
      }
    },

    /**
     * Load selected directory and show files
     * @param path
     */
    selectDirectory(path) {
      // only if this path not selected
      if (!this.isDirectorySelected(path)) {
        this.$store.dispatch('left/selectDirectory', { path, history: true });
      }
    },
    selectPath(path) {
      this.$emit('selected', path);
    },
  },
};
</script>

<style lang="scss">
    .fm-tree-branch {
      display: table;
        width: 100%;
        padding-left: 1.4rem;
        ul {
          padding-left: 1.5em;
          line-height: 1.5em;
          list-style-type: none;
        }

        li > p{
            margin-bottom: 0.1rem;
            padding: 0.4rem 0.4rem;
            white-space: nowrap;
            cursor: pointer;

            &:hover {
              background-color: #f1f5fa;
            }
            &.selected {
              background-color: #e3edf8;
            }
        }

        .fas.fa-minus{
            padding-left: 0.1rem;
            padding-right: 0.6rem;
        }

        .far{
            padding-right: 0.5rem;
        }
    }

    .fade-tree-enter-active, .fade-tree-leave-active {
        transition: all .3s ease;
    }
    // .fade-tree-enter, .fade-tree-leave-to {
    //     transform: translateX(20px);
    //     opacity: 0;
    // }
</style>
